import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { consts } from '../../../common/modals/consts';
import { ILogItem, LogItem, LogItemStatusString } from '../../models/log-item.class';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BugLoggerService } from '../../services/bug-logger.service';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { SettingsProviderService } from '../../../common/settings-provider.service';
import { DocumentService } from '../../../documents/services/document.service';
import { Router } from '@angular/router';
import { FileUpload } from "primeng/fileupload";
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-log-item-editor-modal',
  templateUrl: './log-item-editor-modal.component.html',
  styleUrls: ['./log-item-editor-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LogItemEditorModalComponent implements OnInit {
  documentUploadRequest: FormData;
  settingsProviderService = new SettingsProviderService('ecaApi');
  @Input() modalHeading = 'Log a Problem';
  @Input() editing = false;
  @Input() isReadOnly = false;
  @Input() logItem: ILogItem = new LogItem();
  @Output() saveLogItemRequested: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() cancelRequested: EventEmitter<any> = new EventEmitter<any>();
  acceptedFileTypes = '.doc, .docx,.png, .jpg, .jpeg, .txt,.ppt, .pptx,.xls, .xlsx, .xlsm, .pdf';
  submitted: boolean;
  isEditing = true;
  uploadedFiles: File[] = [];
  maxFileSize = 20971520; // TODO Get max file size from settings.. default to 20mb
  chooseLabel = 'Choose File';
  logItemStatus: typeof LogItemStatusString = LogItemStatusString;
  @ViewChild('uploader', { static: true }) uploader: FileUpload;

  showingHelp: any;
  ctrlFileUploadLabel = 'Attachments';
  sectionOptions = [
    { value: '', label: '' },
    { value: 'Dashboard', label: 'Dashboard' },
    { value: 'EAS Guidance', label: 'EAS Guidance' },
    { value: 'Adding Operatives', label: 'Adding Operatives' },
    { value: 'Editing Operatives', label: 'Editing Operatives' },
    { value: 'Operative Management', label: 'Operative Management' },
    { value: 'Adding Documents', label: 'Adding Documents' },
    { value: 'Editing Documents', label: 'Editing Documents' },
    { value: 'Document Management', label: 'Document Management' },
    { value: 'Adding Training Records', label: 'Adding Training Records' },
    { value: 'Editing Training Records', label: 'Editing Training Records' },
    { value: 'Training Record Management', label: 'Training Record Management' },
    { value: 'Training Courses Management', label: 'Training Courses Management' },
    { value: 'Adding Observations', label: 'Adding Observations' },
    { value: 'Editing Observations', label: 'Editing Observations' },
    { value: 'Observation Management', label: 'Observation Management' },
  ];
  private loggedInuser: IUserInfo;
  rowMenuItems: MenuItem[];

  constructor(private modalRef: DynamicDialogRef,
    private deviceService: DeviceDetectorService,
    private bugLoggerService: BugLoggerService,
    private userService: OurUserService,
    private documentService: DocumentService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.userService?.getLoggedInUser().subscribe(res => {
      this.loggedInuser = res;
    });

    this.rowMenuItems = [
      {
        label: 'Preview',
        icon: 'fas fa-search',
        state: { 'contextLogic': 'canPreviewDocument' },
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.openLogItemDocumentClicked($event)
      },
      {
        label: 'Download',
        icon: 'fas fa-download',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.downloadLogItemDocumentClicked($event)
      }

    ]
  }
  getBrowserDetail() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.logItem.browserDetail = `${deviceInfo?.browser} ${deviceInfo?.browser_version}`;
  }
  saveLogItem() {
       this.modalRef.close();
  }

  editLogItem() {
    this.editing = false;
  }

  cancelClicked() {
    this.cancelRequested.emit();
    this.modalRef.close();
  }

  getHeadingFromOperative() {
    if (!this.logItem?.id || this.logItem.id === consts.emptyGuid) {
      return 'Add a New Issue';
    }
    return 'Update Issue';
  }

  onUpload(event: any) {
    this.uploadedFiles = [];
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
  }

  onRemove(event: any) {
    const index = this.uploader.files.indexOf(event);
    if (index > -1) {
      this.uploader.remove(null, index);
    }
    const fileIndex = this.uploadedFiles?.findIndex(c => c?.name === event?.name);
    this.uploadedFiles.splice(fileIndex, 1);
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }

  editClicked() {

  }

  saveClicked() {
    this.getBrowserDetail();
    this.logItem.appRoute = this.router.url;
    this.logItem.officeId = this.loggedInuser?.companyId;
    this.logItem.foundInVersion = this.settingsProviderService.appVersion;
    this.documentUploadRequest = new FormData();
    const v = this.logItem as {};
    for (const prop in this.logItem) {
      if (this.logItem.hasOwnProperty(prop)) {
        this.documentUploadRequest.append(prop, this.logItem[prop]);
      }
    }
    this.uploadedFiles?.forEach(file => {
      this.documentUploadRequest.append('Files', file);
    });

    this.saveLogItemRequested.emit(this.documentUploadRequest);
  }

  selectedPriorityChanged() {

  }

  viewLogItemDocumentClicked(document: any) {

  }

  downloadLogItemDocumentClicked(document: any) {
    this.documentService.downloadOrOpenDocument(document, true);
  }

  openLogItemDocumentClicked(document: any) {
    this.documentService.downloadOrOpenDocument(document);

  }
}
